import React from 'react';
import { motion } from 'framer-motion';
import { FaGraduationCap } from 'react-icons/fa';
import '../App.css';

const educationList = [
  {
    title: "Bachelor of Engineering Hons. (Cloud Computing)",
    institution: "Chandigarh University",
    year: "2022 - 2025",
    description: "CGPA: 6.72 / 10.0"
  },
  {
    title: "Diploma in Computer Science & Engineering",
    institution: "T.G.B. Government Polytechnic, Shravasti",
    year: "2019 - 2022",
    description: "Percentage: 72.3%"
  },
  {
    title: "Intermediate (Class XII)",
    institution: "Angels Academy Sr. Sec. School, Haridwar",
    year: "2018 - 2019",
    description: "Percentage: 60.2% (CBSE Board)"
  },
  {
    title: "Matriculation (Class X)",
    institution: "Siddharth Public School, Siddharthnagar",
    year: "2016 - 2017",
    description: "CGPA: 9.8 / 10.0 (CBSE Board)"
  }
];

export default function Educations() {
  return (
    <div>
      <h2 className="section-title text-center mb-5">Education</h2>
      <div className="row g-4">
        {educationList.map((edu, index) => (
          <div key={index} className="col-md-6">
            <div className="card-custom h-100">
              <h5 className="text-main fw-bold mb-1">{edu.title}</h5>
              <p className="small text-accent mb-3">{edu.institution} • {edu.year}</p>
              <p className="text-dim mb-0 small">{edu.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
